import { images } from '../../mock';
import { CheckCircle2 } from 'lucide-react';

const points = [
  {
    title: 'Low fee promise',
    text: 'Honest, transparent pricing — no hidden costs or last-minute surprises on the invoice.',
  },
  {
    title: 'We come to you (or you come to us)',
    text: 'Whether in our Woodville office or via a Zoom call, we keep things flexible and personal.',
  },
  {
    title: 'Specialists in farm & rural',
    text: 'Herd Scheme, livestock valuations, National Standard Cost — we get the rural side of things.',
  },
  {
    title: 'Modern cloud accounting',
    text: 'Certified Xero and MYOB partners. We set you up properly so the day-to-day just works.',
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="section-anchor py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="fade-up">
          <div className="brand-divider mb-5" />
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-stone-900 leading-tight">
            Why choose Ask Away?
          </h2>
          <p className="mt-5 text-stone-600 text-[17px] leading-relaxed">
            Choosing the right accountant matters. Here&apos;s what makes working
            with us different.
          </p>

          <ul className="mt-8 space-y-5">
            {points.map((p) => (
              <li key={p.title} className="flex items-start gap-3.5">
                <CheckCircle2 className="h-6 w-6 text-[#0b6b5b] flex-shrink-0 mt-0.5" />
                <div>
                  <div className="font-display font-semibold text-stone-900 text-lg">
                    {p.title}
                  </div>
                  <p className="text-stone-600 text-[15px] leading-relaxed mt-1">
                    {p.text}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="grid grid-cols-2 gap-4 fade-up delay-2">
          <div className="media-card row-span-2 rounded-3xl shadow-lg">
            <img
              src={images.farm}
              alt="NZ farm landscape"
              className="w-full h-full object-cover min-h-[480px]"
            />
          </div>
          <div className="media-card rounded-3xl shadow-lg">
            <img
              src={images.property}
              alt="NZ home property"
              className="w-full h-[230px] object-cover"
            />
          </div>
          <div className="media-card rounded-3xl shadow-lg">
            <img
              src={images.services}
              alt="Accounting calculator"
              className="w-full h-[230px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
